export const strToBoolean = strValue => {
  if (strValue && strValue.toLowerCase() === "false") {
    return false;
  }
  return !!strValue;
};
